var map = {
	"./pr-1.png": "103e",
	"./pr-2.png": "7125",
	"./pr-3.png": "fafc",
	"./pr-4.png": "6bbb",
	"./pr-5.png": "a8c0",
	"./pr-6.png": "0f5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4eb";